import React from 'react'
import Style from './StoreMenu.module.css'
import { HashLink } from 'react-router-hash-link';
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading';
const StoreMenu = (props) => {
   let loading=null
console.log(props)
    if(props.products===undefined){ 
        loading=<div className={Style.SetLoading}>
                    <PointSpreadLoading  color={'#ab0c59'} size={"small"} />
                </div>
    }
    else{
        loading= 
            props.products.map((item)=>  
                <li key={item.id} ><HashLink
                    to={`/supplier/${props.supId}#category${item.id}`}
                    scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                    >{item.category}
                    </HashLink>
                </li>
            )
    }
    return (
        
        <div className={Style.fixList}>
            <ul className={Style.ListHolder}>
                {
                loading
                }
            </ul>
        </div>
    )
}
export default StoreMenu
